import createKeys from '../../utilities/createKeys'

export const Keys = createKeys('DOCUMENTS', [
    'STATE',
    'TYPE_DOCUMENT',
    'VIEW',
    'INFO'
])
